import { ChartThemeColors } from '@customTypes';
import { EChartsOption } from 'echarts';

export const switchChartTheme = (
  options: EChartsOption,
  from: ChartThemeColors,
  to: ChartThemeColors,
): EChartsOption => {
  const result: EChartsOption = JSON.parse(JSON.stringify(options));

  const replaceColors = (obj: EChartsOption) => {
    if (!obj || typeof obj !== 'object') return;

    for (const key in obj) {
      const value = obj[key];

      if (typeof value === 'string') {
        for (const colorKey of Object.keys(from) as (keyof ChartThemeColors)[]) {
          const fromColor = from[colorKey];
          const toColor = to[colorKey];

          if (typeof fromColor === 'string' && value === fromColor) {
            obj[key] = toColor;
            break;
          }
        }

        from.timeSeriesLines.forEach((fromColor, index) => {
          if (value === fromColor && to.timeSeriesLines[index]) {
            obj[key] = to.timeSeriesLines[index];
          }
        });
      } else if (typeof value === 'object') {
        replaceColors(value as EChartsOption);
      }
    }
  };

  const restoreFunctions = (target: EChartsOption, source: EChartsOption) => {
    if (!target || !source || typeof target !== 'object' || typeof source !== 'object') return;

    for (const key in source) {
      if (source[key]) {
        const sourceValue = source[key];
        const targetValue = target[key];

        if (typeof sourceValue === 'function') {
          target[key] = sourceValue;
        } else if (typeof sourceValue === 'object' && typeof targetValue === 'object') {
          restoreFunctions(targetValue as EChartsOption, sourceValue as EChartsOption);
        }
      }
    }
  };

  replaceColors(result);
  restoreFunctions(result, options);

  return result;
};
